<template>
    <DForm
        @submit.prevent="submitForm"
    >
        <input
            type="hidden"
            :value="form.id"
        >
        <DFormRow
            :label="__('settings.permissions.form.name')"
            :is-required="false"
            :error="errors.name"
            :hint="__('settings.permissions.form.name_hint')"
        >
            <DInput
                id="name"
                v-model="form.name"
                name="name"
                maxlength="100"
                :readonly="true"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.permissions.form.description_en')"
            :is-required="false"
            :error="errors.descriptionEn"
            :hint="__('settings.permissions.form.description_en_hint')"
        >
            <DFormTextarea
                id="form_description_en"
                v-model="form.descriptionEn"
                rows="5"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.permissions.form.description_de')"
            :is-required="false"
            :error="errors.descriptionDe"
            :hint="__('settings.permissions.form.description_de_hint')"
        >
            <DFormTextarea
                id="form_description_de"
                v-model="form.descriptionDe"
                rows="5"
            />
        </DFormRow>
        <DFormControls
            :cancel-route="$route('settings.permissions.index')"
            :dirty="form.isDirty"
            @submit="submitForm"
        />
    </DForm>
</template>

<script>
export default {
    name: 'PermissionForm',
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        permission: {
            type: Array,
            default: () => { return [] }
        }
    },
    emits: ['submit'],
    data () {
        return {
            form: this.$inertia.form({
                id: this.permission.id,
                name: this.permission.name,
                descriptionEn: this.permission.description_en,
                descriptionDe: this.permission.description_de
            })
        }
    },
    methods: {
        submitForm () {
            this.$emit('submit', this.form)
        }
    }
}
</script>
